"use client";
import { ScrollArea } from "@base-ui/react/scroll-area";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import SortIcon from "@/components/icons/sort";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { Daum } from "./actions";

const ForumCategoryBar = ({
  parentCategory,
  categories,
}: {
  parentCategory: string;
  categories: Daum[];
}) => {
  const activeCategory = useSearchParams().get("category") || "";
  return (
    <ScrollArea.Root className="max-w-full w-full">
      <ScrollArea.Viewport className="flex flex-row gap-3 items-center flex-nowrap">
        <Button
          className="flex flex-row items-center gap-2 text-neutral-800 font-bold text-sm leading-5 mr-3 cursor-pointer"
          variant="outline"
        >
          Sırala <SortIcon className="w-4 h-4 stroke-brand-blue-600" />
        </Button>
        <Link
          className={cn(
            "rounded-full border border-neutral-200 px-4 py-2 font-medium hover:bg-brand-blue-100 transition-colors",
            {
              "border-brand-blue-600 bg-brand-blue-600 text-white hover:bg-brand-blue-600":
                activeCategory === "",
            },
          )}
          href={`/forum/${parentCategory}`}
          prefetch={false}
        >
          Tümü
        </Link>
        {categories.map((category) => {
          return (
            <div
              className={cn("flex flex-row gap-1", {
                "bg-brand-blue-100 rounded-full w-fit":
                  category.id === activeCategory,
              })}
              key={category.id}
            >
              <Link
                aria-disabled={category.id === activeCategory}
                className={cn(
                  "rounded-full w-fit whitespace-nowrap shrink-0 border border-neutral-200 text-neutral-800 px-4 py-2 font-medium hover:bg-brand-blue-100 hover:border-brand-blue-500 transition-colors",
                  {
                    "border-brand-blue-600 bg-brand-blue-600 text-white hover:bg-brand-blue-600":
                      category.id === activeCategory,
                  },
                )}
                href={`/forum/${parentCategory}?category=${category.id}`}
                prefetch={false}
              >
                {category.name}
              </Link>
            </div>
          );
        })}
      </ScrollArea.Viewport>
      <ScrollArea.Scrollbar className="m-2 flex w-1 justify-center rounded-sm bg-gray-200 opacity-0 transition-opacity pointer-events-none data-hovering:opacity-100 data-hovering:delay-0 data-hovering:pointer-events-auto data-scrolling:opacity-100 data-scrolling:duration-0 data-scrolling:pointer-events-auto">
        <ScrollArea.Thumb className="w-full rounded-sm bg-gray-500" />
      </ScrollArea.Scrollbar>
    </ScrollArea.Root>
  );
};

export default ForumCategoryBar;
